import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import UpgradeGradientSvg from 'assets/svgr-icons/Upgrade_gradient.svg'

export const BannerWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 12px;
  border-radius: ${RADII.field};
  border: 1px solid ${COLORS.borderColor};
  background-color: ${COLORS.primaryTint};
  cursor: pointer;

  &:hover {
    background-color: ${COLORS.fill};
  }
`

export const UpgradeIcon = styled(UpgradeGradientSvg)`
  min-width: 29px;
`

export const TextContent = styled.span`
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.secondaryDark};
  font-weight: 500;
`

export const BoldText = styled.span`
  font-weight: 600;
  color: ${COLORS.purple};
`
